import { render, staticRenderFns } from "./SlideHeaderDiscount.vue?vue&type=template&id=699cd704&scoped=true&"
import script from "./SlideHeaderDiscount.vue?vue&type=script&lang=js&"
export * from "./SlideHeaderDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699cd704",
  null
  
)

export default component.exports